import { createFileRoute } from "@tanstack/react-router";
import { Outlet } from "@tanstack/react-router";
import { Header } from "@/components/layouts/Header";
import { BottomBar } from "@/components/layouts/BottomBar";
import { Footer } from "@/components/layouts/Footer";
export const Route = createFileRoute("/(public)")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex flex-col min-h-screen relative">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <BottomBar />
    </div>
  );
}
